import validate from "/var/www/wait-mate-prod/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.8.7_eslint@8.57.1_ioredis@5.4.1_magicast@0.3_bnrc2r6amrrf75ttwlynwigzyy/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/wait-mate-prod/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.8.7_eslint@8.57.1_ioredis@5.4.1_magicast@0.3_bnrc2r6amrrf75ttwlynwigzyy/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}